export function getNonceTokenFromQueryParams(params: URLSearchParams): string | undefined {
  const nonceToken = params.get("authenticationToken");
  if (!nonceToken) {
    return undefined;
  }
  return nonceToken;
}
